import React, {useEffect, useState} from 'react';
import logo from './logo.svg';
import './App.css';
import Web3 from 'web3';
import Color from './abis/Color.json';

function App() {

    const [colorSelected, setColorSelected] = useState(null);
    const [account, setAccount] = useState('');
    const [contract, setContract] = useState(null);
    const [totalSupply, setTotalSupply] = useState(0);
    const [colors, setColors] = useState([]);

    useEffect(() => {
        const loadWeb3Aux = async () => await loadWeb3()
        const loadBlockchainDataAux = async () => await loadBlockchainData()
        loadWeb3Aux()
        loadBlockchainDataAux()
    }, []);

    const loadWeb3 = async () => {
        // @ts-ignore
        if (window.ethereum) {
            // @ts-ignore
            window.web3 = new Web3(window.ethereum)
            // @ts-ignore
            await window.ethereum.enable()
            // @ts-ignore
        } else if (window.web3) {
            // @ts-ignore
            window.web3 = new Web3(window.web3.currentProvider)
        } else {
            window.alert('!Considera usar metamask')
        }
    }

    const loadBlockchainData = async () => {
        // @ts-ignore
        const web3 = window.web3
        // Load one account
        const accounts = await web3.eth.getAccounts()
        setAccount(accounts[0])
        // const networkId = await web3.eth.net.getId()
        // const networkId = '5777'
        const networkId = '4'
        const networkData = Color.networks[networkId]

        if (networkData) {
            const abi = Color.abi;
            const address = networkData.address;
            const contract = new web3.eth.Contract(abi, address);
            setContract(contract);
            // Function 'totalSupply' of smart contract
            const totalSupply = await contract.methods.totalSupply().call();
            setTotalSupply(totalSupply)
            // Load colors
            for (let i = 1; i <= totalSupply; i++) {
                const color = await contract.methods.colors(i - 1).call()
                // @ts-ignore
                setColors(val => val.concat([color]))
            }
        } else {
            window.alert('Smart Contract no desplegado en la red')
        }
    }

    // Function para crear un nuevo NFT
    const mint = (color: string) => {
        console.log('New NFT in processing!', color)
        // @ts-ignore
        contract.methods.mint(color)
            .send({from: account})
            // @ts-ignore
            .once('receipt', () => setColors(val => val.concat([color])))
    }

    return (
        <div>
            <header id="header" className="header fixed-top d-flex align-items-center">
                <div className="container d-flex align-items-center justify-content-between">

                    <div id="logo">
                        <h1><a><span>RSoft</span> NFT's</a></h1>
                    </div>

                    <nav id="navbar" className="navbar">
                        <ul>
                            <li><a className="nav-link scrollto active" href="#hero">Home</a></li>
                            <li><a className="nav-link scrollto" href="#about-us">About</a></li>
                            <li><a className="nav-link scrollto" href="#features">Features</a></li>
                            <li><a className="nav-link scrollto" href="#contact">Contact</a></li>
                        </ul>
                        <i className="bi bi-list mobile-nav-toggle"/>
                    </nav>

                </div>
            </header>


            <section id="hero">
                <div className="hero-container" data-aos="fade-in">
                    <h1>Welcome to NFT's Colors</h1>
                    <h2>You can create your own NFT color</h2>
                    <img src="assets/img/hero-img.png" alt="Hero Imgs" data-aos="zoom-out" data-aos-delay="100"/>
                    <a href="#get-started" className="btn-get-started scrollto">Connect wallet</a>
                    <div className="btns">
                        <a href="#"><i className="fa fa-apple fa-3x"/> App Store</a>
                        <a href="#"><i className="fa fa-play fa-3x"/> Google Play</a>
                        <a href="#"><i className="fa fa-windows fa-3x"/> windows</a>
                    </div>
                </div>
            </section>

            <main id="main">

                <section id="features" className="padd-section text-center">

                    <div className="container" data-aos="fade-up">
                        <div className="section-title text-center">
                            <h2>Colors NFT's</h2>
                            <p className="separator">Integer cursus bibendum augue ac cursus .</p>
                        </div>
                        <div className="row" data-aos="fade-up" data-aos-delay="100">
                            {colors.map((value, key) => {
                                return (
                                    <div key={key} className="col-md-6 col-lg-3">
                                        <div className="feature-block" style={{backgroundColor: value}}>
                                            <img src="assets/img/svg/paint-palette.svg" alt="img"/>
                                            <h4>{value}</h4>
                                            <p>This color is unique and can not be cloned by anybody</p>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </section>

                <section id="newsletter" className="newsletter text-center">
                    <div className="overlay padd-section">
                        <div className="container" data-aos="zoom-in">
                            <div className="row justify-content-center">
                                <div className="col-md-9 col-lg-6">
                                    <form className="d-flex"
                                          onSubmit={(event) => {
                                              // @ts-ignore
                                              console.log('YTYTYTYTYT', event, colorSelected?.value)

                                              event.preventDefault()
                                              // @ts-ignore
                                              mint(colorSelected?.value)
                                          }}>
                                        <input type="text" className="form-control " placeholder="Ej: #FFFFFF"
                                               ref={(input: any) => setColorSelected(input)}/>
                                        <button type="submit" className="btn btn-default"><i
                                            className="bi bi-location-arrow"/>CREATE NFT
                                        </button>
                                    </form>
                                </div>
                            </div>

                            <ul className="list-unstyled">
                                <li><a href="https://www.facebook.com/RsoftLatam"><i className="bi bi-facebook"/></a>
                                </li>
                                <li><a href="https://twitter.com/rsoft_latam"><i className="bi bi-twitter"/></a></li>
                                <li><a href="https://www.instagram.com/rsoft_latam"><i className="bi bi-instagram"/></a>
                                </li>
                                <li><a href="https://www.youtube.com/c/rsoftlatam"><i className="bi bi-youtube"/></a>
                                </li>
                                <li><a href="https://www.linkedin.com/in/ricardo-pari-534070139"><i
                                    className="bi bi-linkedin"/></a></li>
                                <li><a href="https://github.com/rsoft-latam"><i className="bi bi-github"/></a></li>
                            </ul>

                        </div>
                    </div>
                </section>


                <section id="contact" className="padd-section">

                    <div className="bg-dark flex-md-nowrap p-0 shadow">

                        <ul className="navbar-nav px-3">
                            <li className="nav-item text-nowrap d-none d-sm-none d-sm-block">
                                <small className="text-white">
                                    <span id="account">{account}</span>
                                </small>
                            </li>
                        </ul>

                    </div>

                    <div className="container" data-aos="fade-up">
                        <div className="section-title text-center">
                            <h2>Contact</h2>
                            <p className="separator">Sed ut perspiciatis unde omnis iste natus error sit voluptatem
                                accusantium doloremque</p>
                        </div>

                        <div className="row justify-content-center" data-aos="fade-up" data-aos-delay="100">

                            <div className="col-lg-3 col-md-4">

                                <div className="info">
                                    <div>
                                        <i className="bi bi-geo-alt"/>
                                        <p>Bolivia<br></br>La Paz</p>
                                    </div>

                                    <div className="email">
                                        <i className="bi bi-envelope"/>
                                        <p>rikiricardo16@hotmail.com</p>
                                    </div>

                                    <div>
                                        <i className="bi bi-phone"/>
                                        <p>+591 70141160</p>
                                    </div>
                                </div>

                                <div className="social-links">
                                    <a href="https://www.facebook.com/RsoftLatam"><i className="bi bi-facebook"/></a>
                                    <a href="https://twitter.com/rsoft_latam"><i className="bi bi-twitter"/></a>
                                    <a href="https://www.instagram.com/rsoft_latam"><i className="bi bi-instagram"/></a>
                                    <a href="https://www.youtube.com/c/rsoftlatam"><i className="bi bi-youtube"/></a>
                                    <a href="https://www.linkedin.com/in/ricardo-pari-534070139"><i
                                        className="bi bi-linkedin"/></a>
                                    <a href="https://github.com/rsoft-latam"><i className="bi bi-github"/></a>
                                </div>

                            </div>

                            <div className="col-lg-5 col-md-8">
                                <div className="form">
                                    <form action="forms/contact.php" method="post" role="form"
                                          className="php-email-form">
                                        <div className="form-group">
                                            <input type="text" name="name" className="form-control" id="name"
                                                   placeholder="Your Name" required/>
                                        </div>
                                        <div className="form-group mt-3">
                                            <input type="email" className="form-control" name="email" id="email"
                                                   placeholder="Your Email" required/>
                                        </div>
                                        <div className="form-group mt-3">
                                            <input type="text" className="form-control" name="subject" id="subject"
                                                   placeholder="Subject" required/>
                                        </div>
                                        <div className="form-group mt-3">
                        <textarea className="form-control" name="message" rows={5}
                                  placeholder="Message" required/>
                                        </div>
                                        <div className="my-3">
                                            <div className="loading">Loading</div>
                                            <div className="error-message"/>
                                            <div className="sent-message">Your message has been sent. Thank you!
                                            </div>
                                        </div>
                                        <div className="text-center">
                                            <button type="submit">Send Message</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>


            </main>


            <footer className="footer">
                <div className="container">
                    <div className="row">

                        <div className="col-md-12 col-lg-4">
                            <div className="footer-logo">

                                <a className="navbar-brand" href="#">RSoft</a>
                                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem
                                    Ipsum has been the industry's standard dummy text ever since the.</p>

                            </div>
                        </div>

                        <div className="col-sm-6 col-md-3 col-lg-2">
                            <div className="list-menu">

                                <h4>Abou Us</h4>

                                <ul className="list-unstyled">
                                    <li><a href="#">About us</a></li>
                                    <li><a href="#">Features item</a></li>
                                    <li><a href="#">Live streaming</a></li>
                                    <li><a href="#">Privacy Policy</a></li>
                                </ul>

                            </div>
                        </div>

                        <div className="col-sm-6 col-md-3 col-lg-2">
                            <div className="list-menu">

                                <h4>Abou Us</h4>

                                <ul className="list-unstyled">
                                    <li><a href="#">About us</a></li>
                                    <li><a href="#">Features item</a></li>
                                    <li><a href="#">Live streaming</a></li>
                                    <li><a href="#">Privacy Policy</a></li>
                                </ul>

                            </div>
                        </div>

                        <div className="col-sm-6 col-md-3 col-lg-2">
                            <div className="list-menu">

                                <h4>Support</h4>

                                <ul className="list-unstyled">
                                    <li><a href="#">faq</a></li>
                                    <li><a href="#">Editor help</a></li>
                                    <li><a href="#">Contact us</a></li>
                                    <li><a href="#">Privacy Policy</a></li>
                                </ul>

                            </div>
                        </div>

                        <div className="col-sm-6 col-md-3 col-lg-2">
                            <div className="list-menu">

                                <h4>Abou Us</h4>

                                <ul className="list-unstyled">
                                    <li><a href="#">About us</a></li>
                                    <li><a href="#">Features item</a></li>
                                    <li><a href="#">Privacy Policy</a></li>
                                </ul>

                            </div>
                        </div>

                    </div>
                </div>

                <div className="copyrights">
                    <div className="container">
                        <p>&copy; Copyrights RSoft. All rights reserved.</p>
                        <div className="credits">
                            Designed by <a href="https://rsoft-latam.web.app/">RSoft</a>
                        </div>
                    </div>
                </div>

            </footer>

            <a className="back-to-top d-flex align-items-center justify-content-center">
                <i className="bi bi-arrow-up-short"/>
            </a>

        </div>
    );
}

export default App;
